// extracted by mini-css-extract-plugin
module.exports = {"copyButton":"CopyButton_copyButton__F5Gc7","hoverButton":"CopyButton_hoverButton__O48NS","copyAll":"CopyButton_copyAll__I7GJQ"};